import type { GameStatus, PaginatedGameStatus } from '../types/game';

/** Normalizes GET /game/status — plain array or Laravel `{ data: [...] }`. */
export function unwrapGameStatusList(payload: unknown): GameStatus[] {
  if (Array.isArray(payload)) {
    return payload as GameStatus[];
  }

  if (
    payload &&
    typeof payload === 'object' &&
    'data' in payload &&
    Array.isArray((payload as PaginatedGameStatus).data)
  ) {
    return (payload as PaginatedGameStatus).data;
  }

  return [];
}
